import { render, staticRenderFns } from "./BaseInfoPanel.vue?vue&type=template&id=12302288&scoped=true"
import script from "./BaseInfoPanel.vue?vue&type=script&lang=js"
export * from "./BaseInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoPanel.vue?vue&type=style&index=0&id=12302288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12302288",
  null
  
)

export default component.exports